import { defineComponent } from 'vue'
import { Button } from 'vant'
import type { ButtonType } from 'vant'
import './button-compat.less'

const PRIMARY_BG_CLASS = 'fsw-van-button-primary'

export default defineComponent({
  name: 'VanButton',
  setup(_, { attrs, slots }) {
    return () => {
      const { class: cls, type, ...rest } = attrs as Record<string, unknown>
      const isPrimary = type === 'primary'
      return (
        <Button
          {...rest}
          type={type as ButtonType}
          class={[cls, isPrimary && PRIMARY_BG_CLASS]}
          v-slots={slots}
        />
      )
    }
  },
})
